import type { ScriptConvention } from '@/features/studio/script/useScriptFormatPrefs'

/** 仅清理分集标记与多余空行；不做散文硬拆（格式由 AI 输出 + 解析器负责）。 */
export function prepareFountainBodyForParse(
  body: string,
  _convention: ScriptConvention = 'cn',
): string {
  let text = body.replace(/\r\n/g, '\n').trim()
  if (!text) return text

  return text
    .replace(/^\s*===\s*EPISODE\s+\d+\s*===\s*$/gim, '\n')
    .replace(/^\s*第\s*\d+\s*集\s*$/gim, '\n')
    .replace(/\n{3,}/g, '\n\n')
    .trim()
}
